export const generateId = () => {
  const _timestamp = Date.now()
  const _saltMaximum = 100
  const _salt = Math.floor(Math.random() * Math.floor(_saltMaximum))
  return `${_timestamp}-${_salt}`
}
